import React, { useContext, useEffect, useState } from "react";
import FeatureContainer from "../../../Layout/Containers/FeatureContainer";
import Kalender from "../components/Kalender";
import { Button } from "reactstrap";
import ModalUploadTemplate from "../components/ModalUploadTemplate";
import { PERMISSIONS } from "../../../Constant/FeatureSelection";
import RoleContext from "../../../Context/RoleContext";
import { useKalender } from "../../../Context/KalenderContext";

const KalenderContain = () => {
  const kalenderAPI = useKalender();
  const { checkPermission } = useContext(RoleContext);
  const [acara, setAcara] = useState([]);

  const handleGetTemplate = () => {
    kalenderAPI.getTemplateKalender();
  };

  useEffect(() => {
    refreshEvent();
  }, []);

  const refreshEvent = () => {
    kalenderAPI.getEvent().then((res) => {
      setAcara(res.data);
    });
  };

  const button = (
    <div>
      <ModalUploadTemplate resetState={refreshEvent} />
      <Button onClick={handleGetTemplate}>Template</Button>
    </div>
  );

  const eventParse = (records) => {
    return records?.map((item) => {
      const data = {
        title: item.event,
        start: item.date,
        end: item.date,
      };
      return data;
    });
  };

  return (
    <FeatureContainer title={"Kalender"} createButton={checkPermission(PERMISSIONS.ADD_KALENDER) && button}>
      <Kalender acara={eventParse(acara)} />
    </FeatureContainer>
  );
};
export default KalenderContain;
